import script from "./FriendInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendInfo.vue?vue&type=script&setup=true&lang=js"

import "./FriendInfo.vue?vue&type=style&index=0&id=781173d4&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-781173d4"]])

export default __exports__